import { Injectable, signal } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class OverrideStateService {
  public readonly showAll = signal<boolean>(false)

  public toggle(): void {
    this.showAll.update(val => !val)
  }
}
